import { COLOR_PRIMARY } from "#constants/Styles"
import { Box, Typography } from "@mui/material"

export default function EvaluationStart() {
	return (
		<Box sx={{ textAlign: "center", p: 2 }}>
			<Typography variant="body1" fontWeight="bold" textAlign={"center"} width={"100%"}>
				En este apartado encontrarás una sugerencia para poder empezar con la entrevista.
				Nota: No debe de ser igual solo es para que te apoyes.
			</Typography>

			<Items
				label="Tips para Romper el Hielo:"
				value="Se presenta (saludo y nombre), su puesto actual, presentación del Jefe Inmediato u otro persona que este en la entrevista (si está en la entrevista), hablar un poco de lo que Lubtrac y por último preguntar sobre sus pasatiempos.			"
			/>
			<Items
				label="Saludo y presentación"
				value="Muy buenos días/tardes. Agradecemos su tiempo y disponibilidad para esta entrevista. El propósito de este encuentro es conocer más sobre su trayectoria profesional y la manera en que ha aplicado competencias clave en su ejercicio laboral."
			/>
			<Items
				label="Explicación del proceso"
				value="Le solicitamos que nos brinde una descripción detallada del contexto en el que desarrolló su experiencia, las acciones que implementó y el impacto que logró alcanzar."
			/>
			<Items
				label="Confirmación de disponibilidad"
				value="Antes de dar inicio, ¿se encuentra cómodo(a) y en disposición para continuar, o hay alguna inquietud que desee plantear?			"
			/>
		</Box>
	)
}

const Items = ({ label, value }) => (
	<Box
		sx={{
			display: "flex",
			justifyContent: "left",
			gap: 1,
			border: "1px solid #000000",
		}}
	>
		<Box
			minWidth={"200px"}
			maxWidth={"200px"}
			p={1}
			sx={{
				border: "1px solid #000000",
				backgroundColor: COLOR_PRIMARY,
			}}
		>
			<Typography variant="body1" fontWeight="bold" textAlign={"center"} color="#FFFFFF">
				{label}
			</Typography>
		</Box>
		<Typography variant="body1" textAlign={"center"} p={1} width={"100%"}>
			{value}
		</Typography>
	</Box>
)
